import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getDistance } from 'geolib';

const RobaCard = ({ data, userCoordinates, userId }) => {

  const navigate = useNavigate();
  const objectId = data._id;

//----- CALCOLO LA DISTANZA FRA I DUE UTENTI -----//

  const [supplierDistance, setSupplierDistance] = useState(null);

  const userLat = userCoordinates.lat;
  const userLng = userCoordinates.lng;
  const supplierLat = data.supplier.position.coordinates.lat;
  const supplierLng = data.supplier.position.coordinates.lng;


  const calculateDistance = () => {

    const distance = getDistance(
      { latitude: userLat, longitude: userLng},
      { latitude: supplierLat, longitude: supplierLng},
    );

    setSupplierDistance((distance / 1000).toFixed(1));
  }

  useEffect(() => {
    calculateDistance();
  }, [])

  // ----- //

  const linkToObject = () => {
    navigate(`/robaDetails/${objectId}?distance=${supplierDistance}`)
  }

  return (
    <div className="roba-box" onClick={linkToObject}>
      <div className={data.picked.isPicked === true && data.picked.pickerId === userId ? ('roba-box-img-section picked-border'): ('roba-box-img-section')}>
        <img src={data.photo.resizedUrl} />
      </div>
      <div className="roba-box-info-section">
        <h5 className="black">{data.robaName}</h5>
        <h6>A <span style={{color: '#C63D2F'}}>{supplierDistance}</span> km da casa tua.</h6>
      </div>
    </div>
  )
}

export default RobaCard;
